export const getElementToPreventHorizontalScroll = (
  id: string,
  selector: string
) => {
  const mainContent = document.getElementById(id)
  return mainContent?.querySelector(selector)
}
